import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Space, Typography } from 'antd';
import { useIsMobile } from '@/lib/breakpoints';
/** Consistent page header that stacks vertically on mobile.
 *
 *  Desktop layout:  [Title]                    [Extra actions]
 *  Mobile  layout:  [Title]
 *                   [Extra actions row, wraps if needed]
 */
export function PageHeader({ title, subtitle, extra, compact }) {
    const isMobile = useIsMobile();
    const titleNode = typeof title === 'string' ? (_jsx(Typography.Title, { level: isMobile ? 4 : 3, style: { margin: 0 }, children: title })) : (title);
    return (_jsxs("div", { style: {
            marginBottom: compact ? 12 : 16,
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            alignItems: isMobile ? 'stretch' : 'center',
            justifyContent: 'space-between',
            gap: isMobile ? 12 : 8,
        }, children: [_jsxs("div", { style: { minWidth: 0 }, children: [titleNode, subtitle && (_jsx(Typography.Text, { type: "secondary", style: { fontSize: isMobile ? 12 : 13 }, children: subtitle }))] }), extra && (_jsx(Space, { size: 8, wrap: true, style: { marginLeft: isMobile ? 0 : 'auto' }, children: extra }))] }));
}
